import { Component, OnInit } from '@angular/core';
import { SignupService } from '../services/signup.service';
import { CaseManagementService } from '../services/caseManagement.service';
import { Validators, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { SignUpDataTransferService } from '../services/signup-datatransfer.service';

@Component({
  selector: 'app-signupsuccess',
  templateUrl: './signupsuccess.component.html',
  styleUrls: ['./signupsuccess.component.css']
})
export class SignupsuccessComponent implements OnInit {

  pinDetail: UntypedFormGroup;
  submitted: boolean = false;
  userCode: string;
  loading = false;
  verifyEmail: boolean;
  invalidPin: boolean = false;
  OTP: number;
  booleanPinField: boolean = false;
  companySummaryInformation = {
    companyName: '',
    firstName: '',
    lastName: '',
    email: '',
    cellPhone: '',
    officePhone: '',
    billingEmail: '',
    address: '',
    city: '',
    StateTypeId: '',
  };

  constructor(
    private formBuilder: UntypedFormBuilder,
    private signupService: SignupService,
    private caseManagementService: CaseManagementService,
    private signupDataTransferService: SignUpDataTransferService,
  ) {
  }

  ngOnInit() {
    this.pinDetail = this.formBuilder.group({
      mobilePin: ['', Validators.required],
    });
  }

  showPinField() {
    this.loading = true;
    this.signupService.checkEmailIsVerified(this.signupDataTransferService.getEmailEntered())
      .subscribe((response: any) => {
        if (response[0].customerEmailCount == 0) {
          this.verifyEmail = false;
        } else {
          this.OTP = response[0].mobileOTP;
          this.verifyEmail = true;
        }
        this.booleanPinField = true;
        this.loading = false;
      })
  }

  submitPin() {
    this.submitted = true;
    this.loading = true;
    var pin = this.pinDetail.get('mobilePin').value;
    if (this.pinDetail.invalid) {
      this.loading = false;
      return;
    }
    if (this.OTP == pin) {
      this.signupService.verifyMobileCode(pin)
        .subscribe((response) => {
          sessionStorage.setItem("resEmail", response);
          this.caseManagementService.getCustomerParentInformationId(response).subscribe((res) => {
            sessionStorage.setItem("parentInfoId", res['body']);
          })
        }, (error) => {
          this.loading = false;
          console.error('SignupsuccessComponent_submitPin', error);
        });
    } else {
      this.loading = false;
      this.invalidPin = true;
      return;
    }
  }
}
